import type { SelectableFixture } from "@slot/game-shell";
import { baseFixtureReelNoWin } from "./fixtures/base/base_fixture_reel_no_win";
import { baseFixtureReelAnticipation } from "./fixtures/base/base_fixture_reel_anticipation";
import { baseFixtureReelBigWin } from "./fixtures/base/base_fixture_reel_big_win";
import { baseFixtureReelNiceWin } from "./fixtures/base/base_fixture_reel_nice_win";
import { baseFixtureReelTumble } from "./fixtures/base/base_fixture_reel_tumble";
import { baseFixtureReelCannon } from "./fixtures/base/base_fixture_reel_cannon";
import { baseFixtureReelTumbleChain } from "./fixtures/base/base_fixture_reel_tumble_chain";
import { baseFixtureReelTumbleLong } from "./fixtures/base/base_fixture_reel_tumble_long";
import { baseFixtureReelTumbleDouble } from "./fixtures/base/base_fixture_reel_tumble_double";
import { baseFixtureReelTumbleH } from "./fixtures/base/base_fixture_reel_tumble_h";
import { baseFixtureReelChance } from "./fixtures/base/base_fixture_reel_chance";
import { baseFixtureFeatureTrigger } from "./fixtures/base/base_fixture_feature_trigger";
import { baseFixtureGamble } from "./fixtures/base/base_fixture_gamble";
import { fsFixtureFreeSpins } from "./fixtures/feature/fs_fixture_free_spins";

/**
 * The base-game rounds the dev tools select by id: the hook's `loadFixture(id)` (the e2e suite), the dev
 * menu's playlist, `?fixtures=`. Ids mirror the fixture file names; the order and the groups are the dev
 * menu's.
 */
export const SELECTABLE_FIXTURES: readonly SelectableFixture[] = [
  { id: "reel_no_win", label: "No win", group: "Base", create: baseFixtureReelNoWin },
  { id: "reel_anticipation", label: "Anticipation tease, no win", group: "Base", create: baseFixtureReelAnticipation },
  { id: "reel_tumble", label: "Tumble, 1 step (L1)", group: "Tumbles", create: baseFixtureReelTumble },
  { id: "reel_tumble_h", label: "Tumble, 1 step (H2)", group: "Tumbles", create: baseFixtureReelTumbleH },
  { id: "reel_tumble_double", label: "Two clusters in one step", group: "Tumbles", create: baseFixtureReelTumbleDouble },
  { id: "reel_tumble_chain", label: "Tumble chain, 2 steps", group: "Tumbles", create: baseFixtureReelTumbleChain },
  { id: "reel_tumble_long", label: "Tumble chain, 3 steps", group: "Tumbles", create: baseFixtureReelTumbleLong },
  { id: "reel_cannon", label: "Cannon x2, then x3", group: "Features", create: baseFixtureReelCannon },
  { id: "reel_chance", label: "Chance symbol", group: "Features", create: baseFixtureReelChance },
  { id: "reel_nice_win", label: "Nice win (10×)", group: "Big wins", create: baseFixtureReelNiceWin },
  { id: "reel_big_win", label: "Big win up to epic (120×)", group: "Big wins", create: baseFixtureReelBigWin },
  // Flow fixtures: a bare trigger (the round ends after the panel), a WHOLE free-spins session in
  // one response (trigger spin → feature_enter → feature spins → feature_exit), and a gamble-eligible win.
  { id: "feature_trigger", label: "Free-spins trigger only", group: "Flows", create: baseFixtureFeatureTrigger },
  { id: "fs_free_spins", label: "Free spins, whole session", group: "Flows", create: fsFixtureFreeSpins },
  { id: "gamble", label: "Win with a gamble offer", group: "Flows", create: baseFixtureGamble },
];
